//#region frontend/islands/page-header-slides.js
var PageHeaderSlides = class extends HTMLElement {
	connectedCallback() {
		this.activeIndex = 0;
		this.slides = this.querySelectorAll(".page-header__slide");
		this.circles = this.querySelectorAll(".page-header__slide-circle");
		this.nextButton = this.querySelector(".page-header__next-button");
		this.prevButton = this.querySelector(".page-header__prev-button");
		this.nextButton.addEventListener("click", () => this.setActive(this.activeIndex + 1));
		this.prevButton.addEventListener("click", () => this.setActive(this.activeIndex - 1));
		this.circles.forEach((circle, index) => {
			circle.addEventListener("click", () => this.setActive(index));
		});
	}
	setActive(index) {
		this.slides[this.activeIndex].classList.remove("active");
		this.circles[this.activeIndex].classList.remove("active");
		if (index >= this.slides.length) this.activeIndex = 0;
		else if (index < 0) this.activeIndex = this.slides.length - 1;
		else this.activeIndex = index;
		this.slides[this.activeIndex].classList.add("active");
		this.circles[this.activeIndex].classList.add("active");
	}
};
window.customElements.define("page-header-slides", PageHeaderSlides);
//#endregion
